(function($) {

  /**
   * Equal height
   */
  $.fn.equalHeight = function(options) {

  var maxHeight = 0;
  this.each(function(index) {
    var height = $(this).height();

    if (height > maxHeight) { maxHeight = height };
  });

  return this.each(function(index) {
    $(this).height(maxHeight);
  });

};

  $(document).ready(function() {
    $('.step').equalHeight();
  });

}(jQuery))